export const featureFlags = [
    // these are long-term code refactors that are ongoing
    'XMLParserSwitch', // we are trying to migrate from 'xml2js' to 'fastxml', but getting an issue with different structures

    'ValidateSamplesPhase2', // for backlog item #15368 - future enhancements to #12185 that have been partially started

    // big future release items - remove feature flags after these are released to production
    'APIBasedInvoiceFlips', // backlog item #14807
    'UserGroupsRewrite', // backlog item #16990
    'PasswordChangeRewrite', // backlog item #16936
    'DocumentTotalsCalculationsV2', // backlog item #17457
    'UseOldAuditLog', // kill switch: redesigned audit-log table is default; enable to restore the legacy list/detail view

    'DontCleanDocumentForSave', // backlog item #6966

    'SsoCsp', // backlog item #7302
    'SsoCspNewClient', // backlog item #7302
    'SsoCspGetUserProfile', // backlog item #7302

    // for payments until new invoice search config is readily available
    'PaymentsInvoiceSearch',
    'PaymentsCheckInvoiceSelection',

    'PostSignupSimDirectPost', // backlog item #11404 - alternate single POST /Document path (vs draft+PUT); keep for eventual cutover
    'NewBrandLogin', // backlog item #10661 - gate the new-brand login shell (off in 2.5.0; flip on per env when ready)
] as const;
